// 로그인 — 소셜 우선, 자체 이메일 로그인 병행
import { useState, type FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import { authApi, SocialButtons } from "@taplink/web-shared";
import { ApiError } from "@taplink/web-shared";
import { useAuth } from "@taplink/web-shared";

export function LoginPage() {
  const navigate = useNavigate();
  const { applyToken } = useAuth();

  const [loginId, setLoginId] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (event: FormEvent) => {
    event.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const token = await authApi.login(loginId, password);
      const me = await applyToken(token.accessToken);
      // 약관 미동의 계정은 동의 화면으로 유도(소셜 신규가입 등)
      navigate(me.termsAgreed ? "/" : "/terms", { replace: true });
    } catch (e) {
      setError(e instanceof ApiError ? e.message : "로그인에 실패했습니다.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="page">
      <div className="card">
        <h1>로그인</h1>
        <p className="subtitle">tapLink 관리 콘솔</p>

        {error && <div className="alert alert-error" role="alert">{error}</div>}

        {/* 서버가 켜 둔 공급자만 그린다 — 자격증명이 없으면 버튼과 구분선이 함께 사라진다 */}
        <SocialButtons verb="계속하기" divider="또는 이메일로 로그인" />

        <form onSubmit={onSubmit}>
          <div className="field">
            <label htmlFor="loginId">이메일</label>
            <input
              id="loginId"
              type="email"
              autoComplete="username"
              required
              value={loginId}
              onChange={(e) => setLoginId(e.target.value)}
            />
          </div>

          <div className="field">
            <label htmlFor="password">비밀번호</label>
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <button type="submit" className="btn-primary btn-block" disabled={submitting}>
            {submitting ? "로그인 중…" : "로그인"}
          </button>
        </form>

        <div className="footer-links">
          <Link to="/signup">회원가입</Link>
          <Link to="/forgot-password">비밀번호 찾기</Link>
        </div>
      </div>
    </main>
  );
}
